import { useCallback, useEffect } from 'react'
import { withStyles } from '@aura/components/styles'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router-dom'
import PropTypes from 'prop-types'
import LogoutStatus from '../../constants/logout-status'
import { LOGIN_ROUTE } from '../../constants/routes'
import { useConfig } from '../../utils/config'
import CustomLoader from '../custom-loader'
import styles from './styles'


const Component = ({
    classes,
    logoutOktaSession,
    logoutStatusOkta,
    logoutStatusOAG,
    terminateOAGSession
}) => {
    const config = useConfig()
    const { t: translate } = useTranslation()
    const history = useHistory()

    useEffect(() => {
        if (config?.oktaCurrentSession) {
            logoutOktaSession(config?.oktaCurrentSession)
        }
    }, [])

    const handleLogout = useCallback(() => {
        if (config?.logoutOAGSession) {
            terminateOAGSession(config?.logoutOAGSession)
        }
    }, [])


    useEffect(() => {
        if (logoutStatusOkta === LogoutStatus.SUCCESS || logoutStatusOkta === LogoutStatus.ERROR) {
            handleLogout()
        }
    }, [ logoutStatusOkta ])

    useEffect(() => {
        if (logoutStatusOAG === LogoutStatus.SUCCESS || logoutStatusOAG === LogoutStatus.ERROR) {
            history.push(LOGIN_ROUTE)
        }
    }, [ logoutStatusOAG ])

    if (logoutStatusOkta === LogoutStatus.PENDING || logoutStatusOAG === LogoutStatus.PENDING) {
        return <CustomLoader
            label={translate('loading')}
            style={{ height: '100vh', width: '100vw' }}
        />
    }

    return (<></>)
}

Component.propTypes = {
    classes: PropTypes.shape({
        loader: PropTypes.string
    }),
    logoutOktaSession: PropTypes.func.isRequired,
    logoutStatusOkta: PropTypes.string
}

export default withStyles(Component, styles)
